export default {"src":"/_next/static/image/public/images/ic_close.534a1e0baa0567cbbec75ade1133cce7.svg","height":13,"width":13};